import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 24px;
  border-radius: 4px;
  background: var(--grey-500, #94a6b8);
  svg {
    cursor: pointer;
  }
`;

const Text = styled.div`
  color: var(--secondary-white, #fff);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  /* 14px/regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
`;

const AttachementItem = ({ onClick, name }) => {
  return (
    <Container style={{ margin: 0 }}>
      <Text>{name}</Text>
      <svg
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM11.5355 5.87868L9.41421 8L11.5355 10.1213C11.9261 10.5118 11.9261 11.145 11.5355 11.5355C11.145 11.9261 10.5118 11.9261 10.1213 11.5355L8 9.41421L5.87868 11.5355C5.48816 11.9261 4.85499 11.9261 4.46447 11.5355C4.07394 11.145 4.07394 10.5118 4.46447 10.1213L6.58579 8L4.46447 5.87868C4.07394 5.48816 4.07394 4.85499 4.46447 4.46447C4.85499 4.07394 5.48816 4.07394 5.87868 4.46447L8 6.58579L10.1213 4.46447C10.5118 4.07394 11.145 4.07394 11.5355 4.46447C11.9261 4.85499 11.9261 5.48816 11.5355 5.87868Z"
          fill="#F0F5FF"
        />
      </svg>
    </Container>
  );
};

export default AttachementItem;
